export function isSanitizeDescripValue(value?: string): boolean {
  if (!value) return false;

  // 1. Supprimer les caractères invisibles non imprimables
  const cleaned = value
  .replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "")  // Exclut \n et \r

  // 2. Motifs interdits pour éviter XSS, injection SQL, etc.
  const forbiddenPattern = /[<>[\]{}\\;]|--|\/\*|\*\/|script/i;

  // 3. Retourne true si aucun caractère interdit n'est détecté
  return !forbiddenPattern.test(cleaned);
}
